import { Component, input, Output, EventEmitter, inject, ChangeDetectionStrategy, signal, computed, effect } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { RisrFormTransformer, RisrSchemaForm, AsyncWrapperComponent, RisrForm, RisrFormRenderer, ListApiSearchRequest } from "@fry-it/risr-core";
import { asyncWrapper } from "@fry-it/risr-core";
import { Subject, takeUntil } from "rxjs";
import { ReactiveFormsModule } from "@angular/forms";

@Component({
    selector: 'kz-report-select',
    templateUrl: './report-select.html',
    imports: [
        AsyncWrapperComponent,
        RisrFormRenderer,
        RisrFormRenderer,
        ReactiveFormsModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportSelectComponent {
    config = input.required<any>()
    innerConfig = signal<any | undefined>({});

    // This needs to be the legacy output so that angularjs can bind to it
    @Output() configChange = new EventEmitter<any>();

    private readonly formTransformer = inject(RisrFormTransformer);
    private destroy$ = new Subject<void>();

    protected $reportForm = signal<RisrForm | undefined>(undefined);

    private mainConfig = signal<any | undefined>(undefined);
    private configModel = computed(() => {
        return {
            ...this.mainConfig(),
        }
    });

    private reportSchema: RisrSchemaForm = {
        fields: [
            {
                name: 'report',
                label: 'Select a report',
                type: 'discrete',
                required: true,
                initialValue: '',
                options: {
                    categoriesSource: '/reports-manage/search',
                    categoriesSourceExtraData: { purpose: 'view' },
                    categoriesSourceRequestModifier: (request: ListApiSearchRequest) => {
                        const options = request.options || {};
                        options.modifier = 'stub_group';
                        request.options = options;
                        return request;
                    }
                }
            }
        ]
    }
    formWrapper = asyncWrapper<RisrForm>(async () => {
        const initialValue = {
            report: this.innerConfig().report,
        }
        return await this.formTransformer.fromRisrSchema(this.reportSchema, initialValue);
    });

    constructor() {
        effect(() => {
            this.configChange.emit(this.configModel());
        })
        this.formWrapper.ready.pipe(
            takeUntilDestroyed()
        ).subscribe((form) => {
            if (!form) {
                return;
            }
            this.setupForm(form);
        })

    }

    setupForm(form: RisrForm) {
        form.$value.pipe(
            takeUntil(this.destroy$)
        ).subscribe((value) => {
            this.mainConfig.set(value)
        })
    }

    async ngOnInit() {
        // We want to create a copy so that we can emit to the modified config
        this.innerConfig.set(JSON.parse(JSON.stringify(this.config())));
        this.formWrapper.load();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }


}
